<template>
  <div class="rates-additional-info">
    <span
      class="ml-1 mr-1"
      v-for="(wd, i) in row.weekdays"
      :key="i"
    >{{ wd }}<br v-if="(i + 1) % 3 === 0" /></span>
  </div>
</template>

<script>
export default {
  name: 'CalcFlightsTableCellWeekdays',
  props: {
    row: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellWeekdays.vue